var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('div',{attrs:{"id":"app"}},[(_vm.signedIn)?_c('NavBar'):_vm._e(),_c('router-view')],1),(_vm.signedIn)?_c('CookieBanner'):_vm._e(),(_vm.signedIn)?_c('session-expired-modal'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }